import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { AlternatesModule } from "@hermes/fragments/alternates";

import { StoryBlocksContainerModule } from "@hermes/fragments/chapters";

import { HomePageComponent } from "./components/home-page.component";
import { HomepageRoutingModule } from "./home-page-routing.module";
import { HomePageAnalyticsService } from "./services/home-page-analytics.service";
import { HomePageHeadService } from "./services/home-page-head.service";
import { HomePageTrayService } from "./services/home-page-tray.service";

@NgModule({
    imports: [
        CommonModule,
        StoryBlocksContainerModule,
        HomepageRoutingModule,
        AlternatesModule,
    ],
    declarations: [HomePageComponent],
    providers: [
        HomePageAnalyticsService,
        HomePageHeadService,
        HomePageTrayService,
    ],
})
export class HomePageModule {}
